import * as types from "../actions/ActionTypes";

const defaultState = {
  errorRequestingMailer: false
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case types.MAIL_CLEAR_ERROR:
      return Object.assign({}, state, {
        errorRequestingMailer: false
      });
    case types.MAIL_CASH_OUT_REJECTED:
      return Object.assign({}, state, {
        errorRequestingMailer: true
      });
    case types.MAIL_BUY_TOKENS_REJECTED:
      return Object.assign({}, state, {
        errorRequestingMailer: true
      });
    default:
      return state;
  }
}
